module.exports = __webpack_public_path__ + "media/images/illustrations/protection_plan_standard_small-23a14da4249f20510435ebb3e698937d.svg";